exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700,900);", ""]);

// module
exports.push([module.id, "", ""]);

// exports
